<template>
    <div class="section-stream-embed" :class="color" v-if="stream">
        <layout-contained :class="padding">
            <div class="lg:grid lg:grid-cols-4">
                <div class="lg:col-span-3">
                    <embed-twitch
                        v-if="stream.stream_twitch_username"
                        :username="stream.stream_twitch_username"
                        :image="stream.stream_image_url"
                        @play="onStreamPlay"
                        @progress="onStreamProgress"
                        @pause="onStreamPause"
                        @destroy="onStreamDestroy"
                    >
                        <template v-slot:schedule v-if="overlayNow || overlayNext">
                            <div v-if="overlayNow">
                                <small class="uppercase">Now:</small> {{ overlayNow }} &nbsp; &nbsp;
                            </div>
                            <div v-if="overlayNext"><small class="uppercase">Up Next:</small> {{ overlayNext }}</div>
                        </template>
                    </embed-twitch>
                    <img
                        v-else
                        class="w-full aspect-video object-cover object-[50%_30%]"
                        :src="stream.stream_image_url"
                        alt
                    />
                </div>
            </div>
            <slot name="custom"></slot>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionStreamEmbed',
    props: {
        stream: {
            required: false,
            type: Object,
            default() {
                return {};
            },
        },
        overlayNow: {
            required: false,
            type: String,
            default: null,
        },
        overlayNext: {
            required: false,
            type: String,
            default: null,
        },
        padding: {
            required: false,
            default: 'pt-5 sm:pt-8',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-900',
        },
    },
    methods: {
        patchStream(event) {
            if (!this.stream) return;
            useEntityStream().patch(this.stream.stream_slug, {
                id_stream_play: this.stream.id_stream_play,
                stream_play_total_time: (event.totalTime * 1000).toFixed(0),
                stream_play_current_time: (event.currentTime * 1000).toFixed(0),
            });
        },
        onStreamPlay(event) {
            if (this.$config.public.stage === 'dev') console.log('Stream play:', event);
            this.patchStream(event);
        },
        onStreamProgress(event) {
            // if (this.$config.public.stage === 'dev') console.log('Stream progress:', event);
            if (event.totalTime % 5 === 0) this.patchStream(event);
        },
        onStreamPause(event) {
            if (this.$config.public.stage === 'dev') console.log('Stream pause:', event);
            this.patchStream(event);
        },
        onStreamDestroy(event) {
            if (this.$config.public.stage === 'dev') console.log('Stream destroy:', event);
            this.patchStream(event);
            this.$emit('refresh');
        },
    },
};
</script>
